import * as React from "react";

import {ControlBase, ControlBaseProps, ControlBaseState} from "./ControlBase";
import moment = require("moment/min/moment.min");
import {Moment} from "moment/min/moment.min";
import {ReactUtilities} from "../../utilities/react/ReactUtilities";
import {ValidatorBase} from "../../utilities/validator/ValidatorBase";
import {StoreBase} from "../../utilities/Store/StoreBase";


export abstract class StoreControl <Prop extends StoreControlProps<any>,State extends StoreControlState> extends ControlBase<Prop, State> {
    static defaultProps: Partial<ControlBaseProps> = {};
    private disposer:any=null;
    private validators:ValidatorBase[]=null;
    constructor(props: Prop, context?: any) {
        super(props, context);
    }


    componentWillReceiveProps(nextProps: Readonly<Prop>, nextContext: any): void {
        super.componentWillReceiveProps(nextProps, nextContext);

        if(nextProps.ErrorMessage!=this.props.ErrorMessage||nextProps.IsValid!=this.props.IsValid)
        {
            this.setState({
                ErrorMessage:nextProps.ErrorMessage,
                IsValid:nextProps.IsValid
            })
        }
    }

    public render() {
        return (
            null
        )
    }

    public SetValue(value:any,onChangeArgs:any=null){
        if(this.props.Store!=null) {
            if (typeof this.props.Store['Set' + this.props.PropertyName] != "undefined")
                this.props.Store['Set' + this.props.PropertyName](value);
            else
                this.props.Store.SetValue(this.props.PropertyName, value);
        }

        ReactUtilities.ExecuteMethodPropIfDefined(this.props.onChange,onChangeArgs!=null?onChangeArgs:value);

    }

    componentDidMount(){
        if(this.props.Store!=null)
            this.props.Store.AddField(this);
    }

    componentWillUnmount(){
        if(this.props.Store!=null)
            this.props.Store.RemoveField(this);
    }

    public Validate(){
        if(this.validators==null)
            this.validators=this.GetValidators();

        let isValid=true;
        let errorMessage='';
        for(let validator of this.validators)
        {
            if(!validator.Execute())
            {
                isValid=false;
                errorMessage=validator.ErrorMessage;
            }
        }

        if(this.state.IsValid!=isValid||this.state.ErrorMessage!=errorMessage)
        {
            this.setState({IsValid:isValid,ErrorMessage:errorMessage});
        }

        return isValid;

    }

    public abstract GetValidators():ValidatorBase[];


    public GetValidationSection(){
        return (
            !this.state.IsValid&&this.state.ErrorMessage!=''&&
            <div className="invalid-feedback">
                {this.state.ErrorMessage}
            </div>
        );
    }

    public GetArrayValue(){
        if(this.props.Store==null)
            return this.props.Value;
        let proxyValue= this.props.Store.GetValue(this.props.PropertyName);
        let values=[];
        for(let i=0;i<proxyValue.length;i++)
        {
            values.push(proxyValue[i]);
        }

        return values;
    }

    public GetStringValue(store:any=null, propertyName:any=null){
        if(propertyName===null)
            propertyName=this.props.PropertyName;

        if(store===null)
            store=this.props.Store;

        if(store==null)
            return this.props.Value;
        let value= store.GetValue(propertyName);
        if(value==null)
            return '';
        return value.toString();
    }

    GetBoolValue():any{
        let value:any=0;
        if(this.props.Store==null)
            value=this.props.Value;
        else
            value= this.props.Store.GetValue(this.props.PropertyName);
        if(value==null)
            return false;
        let intVal=parseInt(value);
        if(isNaN(intVal))
            return value==true;
        return intVal==1;
    }

    GetNumericValue() :number{
        let value:any=0;
        if(this.props.Store==null)
            value=this.props.Value;
        else
            value= this.props.Store.GetValue(this.props.PropertyName);
        if(value==null)
            return 0;
        let intVal=parseInt(value);
        if(isNaN(intVal))
            return 0;
        return intVal;
    }

    GetDateValue():Moment{

        let value=this.GetNumericValue();
        if(value==0)
            return null;
        let date= moment.unix(value).utcOffset(0);

        return date;
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
export interface StoreControlProps<S extends StoreBase=any> extends ControlBaseProps{
    Store?:S;
    PropertyName?:keyof S;
    Required?:boolean;
    onChange?:(value:string)=>void;
    key?:any;
    Value?:any;
    IsValid:boolean;
    ErrorMessage:string;
}

export interface StoreControlState extends ControlBaseState{
    IsValid:boolean;
    ErrorMessage:string;
}

//#endregion "My Region"